import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { decorationsStateKey } from './decorators.state';
import { reducer } from './decorators.reducers';
import { DecoratorsEffects } from './decorators.effects';

@NgModule({
  imports: [
    StoreModule.forFeature(decorationsStateKey, reducer),
    EffectsModule.forFeature([DecoratorsEffects]),
  ],
  declarations: [],
  exports: [],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DecoratorStoreModule {}
